var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelKit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFF1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.125 11.55h-3.188a.375.375 0 01-.375-.375v-1.113A2.064 2.064 0 0017.5 8h-3a2.064 2.064 0 00-2.063 2.063v1.112a.375.375 0 01-.374.375H8.874C7.839 11.55 7 12.39 7 13.425v9c0 1.036.84 1.875 1.875 1.875h14.25A1.875 1.875 0 0025 22.425v-9a1.875 1.875 0 00-1.875-1.875zm-8.813-1.488a.19.19 0 01.188-.187h3a.19.19 0 01.188.188v1.112a.375.375 0 01-.375.375h-2.625a.375.375 0 01-.376-.375v-1.113z",
    fill: "#B5393F",
    fillRule: "nonzero"
  }))));
}
export default SvgTravelKit;